import { z } from "zod";

const UpdateLinkRateSchema = z.object({
    name: z.string().min(1, "Name is required"),
    description: z.nullable(z.string()),
    max_night: z.coerce.number().min(0, "Max night cannot be negative"),
    min_night: z.coerce.number().min(1, "Min night must be at least 1"),
    guest_include: z.coerce.number().min(1, "Guest include must be at least 1"),
    guest_max: z.coerce.number().min(1, "Guest max must be at least 1"),
    extra_adult: z.nullable(z.coerce.number()),
    extra_child: z.nullable(z.coerce.number()),
    extra_adult_rate: z.nullable(z.coerce.number()),
    extra_child_rate: z.nullable(z.coerce.number()),
    specific_rule: z.string(),
    specific_value: z.coerce.number(),
    specific_amount_type: z.string(),
    inherit_restriction: z.nullable(z.coerce.number()),
    inherit_closed_to_arrival: z.nullable(z.boolean()),
    inherit_closed_to_departure: z.nullable(z.boolean()),
    inherit_stop_sell: z.nullable(z.boolean()),
    inherit_min_stay_arrival: z.nullable(z.boolean()),
    inherit_min_stay_through: z.nullable(z.boolean()),
    inherit_max_stay: z.nullable(z.boolean()),
}).superRefine((data, ctx) => {
    // Validasi guest_max harus lebih besar atau sama dengan guest_include
    if (data.guest_max < data.guest_include) {
        ctx.addIssue({
            path: ["guest_max"],
            message: "Guest max must be greater than or equal to guest include",
            code: z.ZodIssueCode.custom,
        });
    }

    if (data.inherit_restriction && data.inherit_restriction > 1) {
        ctx.addIssue({
            path: ["inherit_restriction"],
            message: "Inherit restriction must be 0 or 1",
            code: z.ZodIssueCode.custom,
        });
    }
});

export { UpdateLinkRateSchema };
export type UpdateLinkRateForm = z.infer<typeof UpdateLinkRateSchema>;
